import React, {useEffect, useState} from "react";
import {ProductionStageFormRead} from "../../components/production-stages/ProductionStageFormRead";
import {useSearchParams} from "react-router-dom";
import {useGetProductionStageQuery} from "../../store/backend-api/backend.api";

export function ReadProductionStageForm() {
    const [searchParams] = useSearchParams()
    const id = Number(searchParams.get("id"))
    const {data, isSuccess} = useGetProductionStageQuery(id)
    const [key, setKey] = useState(0)

    useEffect(() => {
        setKey((prevState) => prevState + 1)
    }, [data])

    return (<div key={key}>
        {isSuccess && <ProductionStageFormRead data={data}/>}
    </div>)
}